import {useEffect} from 'react';

import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {getManagerDashboardDataACS} from 'store/app/appSlice';

import ManagerGreeting from '../ManagerGreeting/ManagerGreeting';
import Stats from '../Stats/Stats';
import TopItems from '../TopItems/TopItems';
import './ManagerPage.scss';

const ManagerPage = () => {
  const dispatch = useSetGlobalState();
  const {managerDashboardData} = useGlobalState((state) => state.app);
  const {managedPub} = useGlobalState((state) => state.managedPub);

  const stats = [
    {
      type: 'generated-posts',
      value: managerDashboardData?.posts_count || 0,
    },
    {
      type: 'on-tap',
      value: managerDashboardData?.beer_on_taps || 0,
    },
    {
      type: 'beer-styles',
      value: managerDashboardData?.beer_styles_count || 0,
    },
  ];

  useEffect(() => {
    if (managedPub?.id) dispatch(getManagerDashboardDataACS(managedPub.id));
    // eslint-disable-next-line
  }, [managedPub?.id]);

  return (
    <div className="manager-page">
      <section className="row gy-4">
        <div className="manager-page__statistics">
          <div className="row g-3">
            <div className="col-xl-6">
              <ManagerGreeting />
            </div>
            <div className="col-xl-6">
              <div className="manager-page__stats">
                <div className="row g-2">
                  <Stats stats={stats} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <TopItems />
      </section>
      <section className="manager-page__coming-soon">
        <Text tag="h4" uppercase>
          Recent posts
        </Text>
        <div className="manager-page__coming-soon-info">
          <Text tag="span" uppercase>
            Coming Soon
          </Text>
        </div>
        <div className="manager-page__coming-soon-items">
          <div className="manager-page__coming-soon-item">
            <Icon icon="image-placeholder" />
          </div>
          <div className="manager-page__coming-soon-item">
            <Icon icon="image-placeholder" />
          </div>
          <div className="manager-page__coming-soon-item">
            <Icon icon="image-placeholder" />
          </div>
        </div>
        <div className="manager-page__coming-soon-view-all">
          <Text tag="span">View All</Text>
        </div>
      </section>
    </div>
  );
};

export default ManagerPage;
